import styled from '@emotion/styled';
import { colors } from '../../../../../themes';

export const DropdownSearchWrapper = styled.div`
  display: flex;
  padding: 16px;
  border-bottom: 1px solid ${colors.monochrome.grey20};
`;
